import { useEffect } from 'react';
import type { Editor } from '@tiptap/react';

import useScrollContent from '@modules/documents/hooks/useScrollContent.hook';
import { resolveStaticContentLinkTarget } from '@modules/documents/helpers/scrollContent/staticContentLinkTarget';
import {
  AI_EDIT_PREVIEW_ID_ATTRIBUTE,
  AI_EDIT_PREVIEW_WIDGET_CLASS,
} from '@modules/documents/tiptap/plugins/AiEditReviewPlugin';

const useAiEditPreviewLinkClicks = (editor: Editor | undefined) => {
  const scrollContent = useScrollContent();

  useEffect(() => {
    const dom = editor?.view?.dom;
    if (!editor || !dom) return;

    const onClick = (event: MouseEvent) => {
      if (!(event.target instanceof Element) || !event.target.closest(`.${AI_EDIT_PREVIEW_WIDGET_CLASS}`)) return;
      const target = resolveStaticContentLinkTarget(event.target);
      if (!target) return;

      // Stops the anchor's hash navigation and every other click handler on the target.
      event.preventDefault();
      event.stopPropagation();
      // A caption or heading the run inserts exists only in a widget, under the widget's own id.
      scrollContent({ value: target.value, attribute: AI_EDIT_PREVIEW_ID_ATTRIBUTE, noFocus: true });
    };

    dom.addEventListener('click', onClick, true);
    return () => dom.removeEventListener('click', onClick, true);
  }, [editor, scrollContent]);
};

export default useAiEditPreviewLinkClicks;
